import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';

const ApprovalTypeHeaderLinks = ({ onClose, onSave, disabledSave }) => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton fontSize='medium' color='transparent' tooltip={t('ApprovalTypes.BackToList')} onClick={onClose}>
        <ArrowBack />
      </IconButton>
      <IconButton
        type='save'
        fontSize='medium'
        color='transparent'
        tooltip={t('ApprovalTypes.SaveChanges')}
        onClick={onSave}
        disabled={disabledSave}
      />
    </>
  );
};

ApprovalTypeHeaderLinks.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  disabledSave: PropTypes.bool.isRequired
};

export default ApprovalTypeHeaderLinks;
